export default __webpack_public_path__ + "static/logo-0269c60f1aef791ca8f26a552480466f.svg";